import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import Bank from "../../entities/Bank";
import i18n from "../../i18n";
import { apiCallBegan } from "../api";
import { AppDispatch, AppState } from "../configureStore";
import ResponseBase from "../types/ResponseBase";
import SliceCollectionBase from "../types/SliceCollectionBase";
import { authHeader } from "../users/auth";

// RESPONSE DECLARATIONS //
interface BankResponse extends ResponseBase {
  Code: string;
  Name: string;
}

type ClassificatorResponse<T> = T[] | { value: T[] };

// SLICE //
interface State extends SliceCollectionBase<Bank> { }

const initialState: State = {
  list: [],
  loading: false,
  lastFetch: null,
  error: null
}

const slice = createSlice({
  name: "banks",
  initialState,
  reducers: {
    // BANKS
    banksRequested: (banks) => {
      banks.loading = true;
      banks.error = null;
    },
    banksReceived: (banks, action: PayloadAction<ClassificatorResponse<BankResponse>>) => {
      banks.list = schema(unwrapClassificatorResponse(action.payload));
      banks.loading = false;
      banks.lastFetch = Date.now();
    },
    banksRequestFailed: (banks, action) => {
      banks.loading = false;
      banks.error = action.payload;
    }
  }
});

const {
  banksRequested,
  banksReceived,
  banksRequestFailed
} = slice.actions;

export default slice.reducer;

// ACTION CREATORS //
//Candidate portal//
export const getBanks = () => async (dispatch: AppDispatch, getState: () => AppState) => {
  if (getState().entities.banks.loading) {
    return;
  }

  const companyId = getState().users.auth.data?.CompanyId ?? 0;

  const url = `/api/Classificator/banks?companyId=${companyId}`;

  var result =  await dispatch(
    apiCallBegan({
      url,
      method: "GET",
      headers: { ...authHeader(), "Accept-Language": i18n.language },
      onStart: banksRequested.type,
      onSuccess: banksReceived.type,
      onError: banksRequestFailed.type
    })
  );
  return result
}

// NORMALIZATION //
const schema = (payload: BankResponse[]): Bank[] => {
  if (!payload || payload.length === 0) {
    return [];
  }

  return payload.map((resp: BankResponse): Bank => (
    {
      Code: resp.Code,
      Id: resp.Id,
      Name: resp.Name
    }
  ))
};

const unwrapClassificatorResponse = <T>(payload: ClassificatorResponse<T>): T[] => {
  if (Array.isArray(payload)) {
    return payload;
  }

  return payload?.value || [];
};
